export function replaceWith(targetElement, html) {
  let div = document.createElement('div')
  div.innerHTML = html.trim()
  let newElement = div.firstChild
  targetElement.parentNode.replaceChild(newElement, targetElement)
  return newElement
}
